<template>
  <div class="card">
    <div class="card-header">
      <p class="card-header-title">Ajouter un nouveau contenu</p>
      <span class="icon has-text-info help-btn">
        <a href="https://theadmin.thecompagnie.eu/doc?bloc=Type%20de%20contenu%20multiple" target="_blank"><i class="fa fa-question-circle"></i></a>
      </span>
    </div>
    <div class="card-content">
      <div class="content">
        <div class="columns">
          <div class="column is-two-thirds">

            <!-- Textbox fields -->
            <div class="field" v-for="(field, index) in fields" :key="index" v-if="field.type === 'textbox'">
              <label class="label">{{ field.name }}</label>
              <div class="control">
                <input type="text" class="input" maxlength="25" required :placeholder="field.name" v-model="newContent[field.name]">
              </div>
            </div>

            <!-- Textarea fields -->
            <div class="field" v-for="(field, index) in fields" :key="index" v-if="field.type === 'textarea'">
              <label class="label">{{ field.name }}</label>
              <div class="control">
                <textarea class="input" v-model="newContent[field.name]" :placeholder="field.name" v-text="newContent[field.name]"></textarea>
              </div>
            </div>

            <!-- Rich text fields - vue-quill-editor plugin -->
            <div class="field" v-for="(field, index) in fields" :key="index" v-if="field.type === 'richtextbox'">
              <label class="label">{{ field.name }}</label>
              <quill-editor v-model="newContent[field.name]" :options="editorOptions">
              </quill-editor>
              <input type="file" id="getImage" style="display: none;" @change="uploadImage">
            </div>

            <!-- Category fields -->
            <br>
            <div class="field" v-for="(field, index) in fields" :key="index" v-if="field.type === 'select'">
              <label class="label">{{ field.name }}</label>
              <div class="control">
                <input type="text" class="input" :placeholder="field.name" v-model="newContent[field.name]" maxlength="25">
              </div>
            </div>

          </div>

          <!-- Right sidebar -->
          <div class="column is-one-third">

            <!-- Tag fields -->
            <div class="field" v-for="(field, index) in fields" :key="index" v-if="field.type === 'tags'">
              <label class="label">{{ field.name }}</label>
              <div class="control">
                <div class="tags tagscontainer">
                <span @click="removeTag(tagKey, field.name)" v-for="(tag, tagKey) in newContent[field.name]" :key="tagKey" class="tag is-info pointer">{{tag}}<button class="delete is-small"></button></span>
                <input :placeholder="field.name" @keyup.enter="styleTags(field.name)" type="text" class="input" maxlength="25" v-model="inputData">
                </div>
                <p>Séparer les tags avec des virgules ","</p>
              </div>
            </div>

            <!-- Image fields -->
            <div class="field" v-for="(field, index) in fields" :key="index" v-if="field.type === 'image'">
              <label class="label">{{ field.name }}</label>
              <div class="control">
                <img :src="newContent[field.name]">
                <p v-if="imageUploaded">
                  Image ajoutée!
                </p>
                <div class="file">
                  <label class="file-label">
                    <input @change="uploadFeaturedImage($event, field.name)" class="file-input" type="file" name="resume">
                    <span class="file-cta">
                      <span class="file-icon">
                        <i class="fa fa-upload"></i>
                      </span>
                      <span class="file-label">
                        Télécharger
                      </span>
                    </span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- notification -->
        <div v-if="notification.message" :class="'notification is-' + notification.type">
          <button class="delete" @click="hideNotifications"></button>{{notification.message}}
        </div>

        <!-- the form buttons -->
        <button type="submit" class="button is-success" @click="add('published')">Publier</button>
        <button type="submit" class="button is-info" @click="add('saved')">Enregistrer le brouillon</button>
        <router-link :to="'/admin/content/' + $route.params.key" class="button is-danger">Annuler</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase'
import { mediaRef } from '@/admin/firebase_config'
import editorOptions from '@/admin/utils/editor-options'
import imageLoader from '@/admin/mixins/image-loader'
import notifier from '@/admin/mixins/notifier'

export default {
  name: 'content-new',
  firebase: {
    media: mediaRef
  },
  props: ['add-content', 'fields'],
  mixins: [imageLoader, notifier],
  data () {
    return {
      newContent: {},
      tags: [],
      inputData: '',
      editorOptions,
      imageUploaded: false
    }
  },
  methods: {
    add (state) {
      this.newContent.created = Date.now()
      this.newContent.selected = false
      this.newContent.state = state
      this.imageUploaded = false
      this.addContent(this.newContent)
      this.$router.push({ path: '/admin/content/' + this.$route.params.key })
    },
    uploadFeaturedImage (e, fieldName) {
      console.log(e)
      let file = e.target.files[0]
      let storageRef = firebase.storage().ref('images/' + new Date().getMinutes() + new Date().getSeconds() + file.name)

      storageRef.put(file).then((snapshot) => {
        console.log(snapshot)
        this.imageUploaded = true
        this.newContent[fieldName] = ''
        this.newContent[fieldName] = snapshot.downloadURL
        if (Object.values(this.media).find(e => e.path === snapshot.ref.fullPath)) return // this prevents duplicate entries in the media object
        this.$firebaseRefs.media.push({
          src: snapshot.downloadURL,
          path: snapshot.ref.fullPath,
          name: snapshot.metadata.name
        })
      })
    },
    styleTags (fieldName) {
      if (this.inputData !== '') {
        if (!this.newContent[fieldName]) {
          this.newContent[fieldName] = []
        }
        this.newContent[fieldName].push(`${this.inputData.trim()}`)
        this.inputData = ''
      }
    },
    removeTag (index, fieldName) {
      this.newContent[fieldName].splice(index, 1)
    }
  }
}

</script>

<style lang="scss" scoped>
.tagscontainer {
  border: 2px solid #f2f2f2;
  border-radius: 5px;
  padding: 5px;
}
.pointer {
  cursor: pointer;
}
.section{
  padding: 0 !important;
  padding-top: 1em !important;
}
.bulma .card .card-content.principal{
  padding: 0 !important;
}
.bulma .card-content{
  padding: 0 !important;
}
.bulma .columns{
  padding: 0 !important;
}
.bulma .column{
  padding: 0 !important;
}
.content{
  padding: 1em !important;
}
</style>



// WEBPACK FOOTER //
// src/admin/pages/content/contents/ContentsNew.vue